/* eslint-disable import/prefer-default-export */
import qs from 'querystring';
import _ from 'lodash';

export const getGoogleMapsUrl = (home = {}) => {
  const { address1, city, latitude, longitude, state, zipcode } = home;

  const params = {
    q: '',
  };

  if (latitude && longitude) {
    params.q = `${latitude},${longitude}`;
  } else {
    params.q = `${address1}+${city}+${state}+${zipcode}`;
  }

  return `https://www.google.com/maps?${qs.stringify(params)}`;
};

export const getGoogleStaticMapImageUrl = ({ home, pinColor, zoom, height, width, maptype }) => {
  let center;
  const latitude = _.get(home, 'latitude');
  const longitude = _.get(home, 'longitude');
  const address = _.get(home, 'address1');
  const city = _.get(home, 'city');
  const state = _.get(home, 'state');
  const zipcode = _.get(home, 'zipcode');

  const propertyHasAddress = address && city && zipcode;

  if (latitude && longitude) {
    center = `${home.latitude},${home.longitude}`;
  } else if (propertyHasAddress) {
    center = `${address}+${city}${state ? `+${state}` : ''}+${zipcode}`;
  }

  if (!center) return null;

  const params = {
    center,
    zoom,
    size: `${width}x${height}`,
    scale: 2,
    maptype,
    markers: `color:${pinColor || 'blue'}|${center}`,
    key: process.env.GOOGLE_MAPS_STATIC_API_KEY,
  };

  return `https://maps.googleapis.com/maps/api/staticmap?${qs.stringify(params)}`;
};

export const checkIsGoogleImageCorrect = async googleImageLink => {
  const CORRECT_IMAGE_LENGTH = 8000;
  const response = await fetch(googleImageLink);
  const contentLength = response.headers.get('content-length');

  if (contentLength > CORRECT_IMAGE_LENGTH) return true;

  return false;
};
